/**
 * @generated SignedSource<<437bd26a8b49571fa05ae3acd72b99c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RequestClientAssetUploadInput = {
  projectId: string;
  fileName: string;
  sizeBytes: number;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type clientAssetMutationsRequestUploadMutation$variables = {
  input: RequestClientAssetUploadInput;
};
export type clientAssetMutationsRequestUploadMutation$data = {
  readonly requestClientAssetUpload: {
    readonly ticket: {
      readonly uploadUrl: string;
      readonly storageKey: string;
      readonly contentType: string;
      readonly expiresAt: string;
    } | null;
  } | null;
};
export type clientAssetMutationsRequestUploadMutation = {
  variables: clientAssetMutationsRequestUploadMutation$variables;
  response: clientAssetMutationsRequestUploadMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestClientAssetUploadPayload",
    "kind": "LinkedField",
    "name": "requestClientAssetUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientAssetUploadTicket",
        "kind": "LinkedField",
        "name": "ticket",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "storageKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientAssetMutationsRequestUploadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientAssetMutationsRequestUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "231b114acbfc88fb8ebcf61d5e1d3af6",
    "id": null,
    "metadata": {},
    "name": "clientAssetMutationsRequestUploadMutation",
    "operationKind": "mutation",
    "text": "mutation clientAssetMutationsRequestUploadMutation(\n  $input: RequestClientAssetUploadInput!\n) {\n  requestClientAssetUpload(input: $input) {\n    ticket {\n      uploadUrl\n      storageKey\n      contentType\n      expiresAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2634e10a55b28840985aa23f7a4f295a";

export default node;
